(function () {
  var STORAGE_KEY = "betterdog_openai_attribution";
  var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  var ATTR_PREFIX = "openai_";
  var UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "utm_id"
  ];
  var OPENAI_KEYS = [
    "oppref",
    "__oppref",
    "openai_click_id",
    "oai_click_id",
    "oai_ad_id",
    "oai_campaign_id",
    "oai_adgroup_id"
  ];

  function now() {
    return Date.now();
  }

  function getParams() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (error) {
      return new URLSearchParams("");
    }
  }

  function getCookie(name) {
    var cookies = document.cookie ? document.cookie.split("; ") : [];
    for (var i = 0; i < cookies.length; i += 1) {
      var pair = cookies[i].split("=");
      if (pair[0] === name) {
        return pair.slice(1).join("=");
      }
    }
    return "";
  }

  function isOpenAISource(value) {
    return /openai|chatgpt|chat\.openai/i.test(String(value || ""));
  }

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        return null;
      }
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.captured_at) {
        return null;
      }
      if (now() - Number(parsed.captured_at) > MAX_AGE_MS) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function writeStored(data) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      return;
    }
  }

  function buildCurrentAttribution() {
    var params = getParams();
    var attribution = {
      attribution_source: "",
      captured_at: now(),
      landing_page: window.location.href,
      referrer: document.referrer || ""
    };
    var hasOpenAISignal = false;

    UTM_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) {
        attribution[key] = value;
      }
      if (key === "utm_source" && isOpenAISource(value)) {
        hasOpenAISignal = true;
      }
    });

    OPENAI_KEYS.forEach(function (key) {
      var value = params.get(key) || getCookie(key);
      if (value) {
        attribution[key.replace(/^__/, "")] = value;
        hasOpenAISignal = true;
      }
    });

    if (isOpenAISource(attribution.referrer)) {
      hasOpenAISignal = true;
    }

    if (!hasOpenAISignal) {
      return null;
    }

    attribution.attribution_source = "openai_ads";
    return attribution;
  }

  function trimValue(value) {
    return String(value || "").slice(0, 500);
  }

  function toCartAttributes(attribution) {
    var attrs = {};
    Object.keys(attribution).forEach(function (key) {
      if (attribution[key] !== undefined && attribution[key] !== null && attribution[key] !== "") {
        attrs[ATTR_PREFIX + key] = trimValue(attribution[key]);
      }
    });
    attrs[ATTR_PREFIX + "proof_version"] = "2026-06-30";
    return attrs;
  }

  function updateCartAttributes(attribution) {
    if (!attribution || !window.fetch) {
      return;
    }

    window.fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        attributes: toCartAttributes(attribution)
      })
    }).catch(function () {});
  }

  function addHiddenInputs(form, attribution) {
    if (!form || !attribution) {
      return;
    }
    var attrs = toCartAttributes(attribution);
    Object.keys(attrs).forEach(function (key) {
      if (form.querySelector('input[name="attributes[' + key + ']"]')) {
        return;
      }
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "attributes[" + key + "]";
      input.value = attrs[key];
      form.appendChild(input);
    });
  }

  function wireCheckoutForms(attribution) {
    var selector = 'form[action*="/cart"], form[action*="/checkout"], form[action="/cart"]';
    var forms = document.querySelectorAll(selector);
    forms.forEach(function (form) {
      addHiddenInputs(form, attribution);
      form.addEventListener("submit", function () {
        updateCartAttributes(attribution);
      }, { passive: true });
    });

    document.addEventListener("click", function (event) {
      var target = event.target && event.target.closest ? event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]') : null;
      if (target) {
        updateCartAttributes(attribution);
      }
    }, true);
  }

  var current = buildCurrentAttribution();
  var stored = readStored();
  var attribution = current || stored;

  if (current) {
    writeStored(current);
    attribution = current;
  }

  if (!attribution) {
    return;
  }

  if (current) {
    updateCartAttributes(attribution);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      wireCheckoutForms(attribution);
    });
  } else {
    wireCheckoutForms(attribution);
  }
})();
